import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDbIcCheckCircle24 = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "icon",
	height: 24,
	viewBox: "0 0 24 24",
	width: 24,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m12 2a9.99 9.99 0 0 1 10 10 9.99 9.99 0 0 1 -10 10 9.99 9.99 0 0 1 -10-10 9.99 9.99 0 0 1 10-10zm0 2c-4.438 0-8 3.563-8 8 0 4.438 3.563 8 8 8 4.438 0 8-3.563 8-8 0-4.438-3.563-8-8-8zm4.5 4.375a.97.97 0 0 0 -.688.281l-5.656 5.656-2.031-2c-.219-.218-.406-.312-.688-.312-.53 0-1 .438-1 1 0 .25.094.531.282.719l2.718 2.719c.22.218.438.312.688.312.281 0 .531-.125.719-.313l6.375-6.343a.99.99 0 0 0 .312-.75c0-.5-.468-.969-1.031-.969z",
		fill: "var(--db-icon-color, currentColor)",
		fillRule: "evenodd"
	})
});
export default SvgDbIcCheckCircle24;
